/*
  PW Offers — cart sync for the revamp theme.
  Ported from the old theme's pw-offers.js (v2.3.0-pw). The PDP section (pw-pdp.liquid)
  adds the gift lines; this file keeps the cart honest afterwards:
    - removes free gift lines (_pw_auto_item) whose paid qualifying item is gone
    - caps gift quantities to gift_qty x maximum_applications_per_order
    - stores the active offer in the `_pw_active_offer` cart attribute (as the old theme did)
*/
(function () {
  if (window.PWOffers) return;

  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  var CACHE_PREFIX = 'pw_offer_config_';
  var SESSION_KEY = 'pw_active_offer';
  var CART_ATTR_KEY = '_pw_active_offer';

  function postJSON(path, body) {
    return fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function getCart() { return fetch(ROOT + '/cart.js').then(function (r) { return r.json(); }); }

  function cacheConfig(cfg) {
    if (!cfg || !cfg.offer_id) return;
    try {
      var key = CACHE_PREFIX + cfg.offer_id;
      var prev = JSON.parse(localStorage.getItem(key) || 'null');
      /* Merge qualifying ids across products that share one offer (collection offers). */
      if (prev && prev.qualifying_variant_ids) {
        var ids = prev.qualifying_variant_ids.concat(cfg.qualifying_variant_ids || []);
        cfg = Object.assign({}, cfg, { qualifying_variant_ids: ids.filter(function (v, i) { return ids.indexOf(v) === i; }) });
      }
      localStorage.setItem(key, JSON.stringify(cfg));
    } catch (e) {}
  }
  function getConfig(offerId) {
    try { return JSON.parse(localStorage.getItem(CACHE_PREFIX + offerId) || 'null'); } catch (e) { return null; }
  }

  function isAuto(item) { return item.properties && item.properties._pw_auto_item === 'true'; }

  var locked = false, pending = false;

  function sync() {
    if (locked) { pending = true; return Promise.resolve(); }
    locked = true;
    var changed = false;
    return getCart().then(function (cart) {
      var autoItems = cart.items.filter(isAuto);
      if (!autoItems.length) return;
      var paid = cart.items.filter(function (i) { return !isAuto(i); });
      var work = Promise.resolve();

      autoItems.forEach(function (item) {
        var role = item.properties._pw_offer_role;
        if (role === 'bundle_component') return;
        var cfg = getConfig(item.properties._pw_offer_id);
        if (!cfg) return; /* unknown offer: leave it alone (old behaviour) */

        var qualifying = paid.filter(function (p) {
          return (cfg.qualifying_variant_ids || []).indexOf(p.variant_id) !== -1;
        });
        var target;
        if (!qualifying.length) {
          target = 0;
        } else {
          var apps = Math.max(1, parseInt(cfg.maximum_applications_per_order, 10) || 1);
          var paidQty = qualifying.reduce(function (s, p) { return s + p.quantity; }, 0);
          var per = role === 'same_product_bogo' ? (cfg.same_variant_gift_quantity || 1) : (cfg.inventory_gift_quantity || 1);
          target = per * Math.min(paidQty, apps);
        }
        if (item.quantity > target) {
          changed = true;
          work = work.then(function () { return postJSON('/cart/change.js', { id: item.key, quantity: target }); });
        }
      });
      return work;
    }).then(function () {
      if (changed) {
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pw-offers' });
        }
      }
    }).catch(function (e) { console.error('[PWOffers] sync failed', e); })
      .then(function () {
        locked = false;
        if (pending) { pending = false; scheduleSync(); }
      });
  }

  var timer;
  function scheduleSync() { clearTimeout(timer); timer = setTimeout(sync, 400); }

  window.PWOffers = {
    version: '3.0.0-revamp',
    cacheConfig: cacheConfig,
    sync: sync,
    setActiveOffer: function (offerId) {
      try { sessionStorage.setItem(SESSION_KEY, offerId); } catch (e) {}
      var attrs = {}; attrs[CART_ATTR_KEY] = offerId;
      /* Awaited by nobody on purpose — the attribute is informational. */
      return postJSON('/cart/update.js', { attributes: attrs }).catch(function () {});
    }
  };

  function init() {
    document.querySelectorAll('[data-pw-offer-config]').forEach(function (el) {
      try { cacheConfig(JSON.parse(el.textContent)); } catch (e) {}
    });
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (evt && evt.source === 'pw-offers') return;
        scheduleSync();
      });
    }
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
